// 「数据模板」复制：基于已有模板生成新模板的创建参数。
// 内容（字段/分组/行配置/计算/校验）整份照搬，只把内部表头标题换成新名称；
// 不带原模板 id，所以创建出来的是独立的新模板，原模板和用它的项目不受影响。
// 没有字段列表（如新建后从未保存的 "{}"）的内容原样复制：编辑器 loadTemplate 只对 "{}"
// 跳过解析，补进 title 会让它去遍历不存在的 questions，副本就打不开了。

export function defaultCopyName(name) {
  return `${name || "未命名模板"}（副本）`;
}

export function buildTemplateCopy(source, form) {
  let content;
  try {
    content = JSON.parse(source.content);
  } catch (e) {
    throw new Error("原模板内容格式错误，无法复制");
  }
  if (!content || typeof content !== "object" || Array.isArray(content)) {
    throw new Error("原模板内容格式错误，无法复制");
  }

  return {
    name: form.name,
    template_type: form.template_type,
    sub_department_id: form.sub_department_id,
    content: JSON.stringify(
      Array.isArray(content.questions) ? { ...content, title: form.name } : content
    ),
  };
}
